import { render, staticRenderFns } from "./VerifySMS.vue?vue&type=template&id=128151b8&"
import script from "./VerifySMS.vue?vue&type=script&lang=js&"
export * from "./VerifySMS.vue?vue&type=script&lang=js&"
import style0 from "./VerifySMS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports